type Resolver = () => boolean

let resolver: Resolver | null = null

/** Test/seam hook: inject the flag source. Production wires this to remote config. */
export const __setNativeSupportChatResolver = (fn: Resolver | null): void => {
  resolver = fn
}

/**
 * Whether to open the native Atlas support chat. When false (kill-switch off or
 * resolver unset), the help UI falls back to the web help center. Never throws.
 */
export const shouldUseNativeSupportChat = (): boolean => {
  if (!resolver) return false
  try {
    return resolver() === true
  } catch {
    return false
  }
}
